import React, { useEffect, useState, useRef, useMemo } from 'react'
import { trans } from '../../../_providers/Translation'

import { useHistory, useLocation, Link, useParams } from 'react-router-dom'
import Api from '../../../_helpers/Api'
import loader from '../../../assets/img/loader.svg'
import Filter from './partials/FilterProfitVat'
import { useAuthDataContext } from '../../../_providers/Auth'
import style from '../../../assets/css/accounts.css'
import * as Constants from '../../../_config/app'
import GroupedBarChart from '../../partials/GroupedBarChart'
import { getPaletteColor } from '../../partials/chartTheme'

let timeout

function ProfitVat() {

    const auth = useAuthDataContext()
    const params = useParams()
    const history = useHistory()
    const location = useLocation()
    const searchParams = new URLSearchParams(location.search)

    const [state, setState] = useState({
        loading: true,
        data: {},
        filter: {},
        setFilter: false,
        update: false,
    })

    useEffect(() => {
        setState(prev => ({
            ...prev,
            page: searchParams.get('page') || 1,
            filter: {
                ...prev.filter,
                group: searchParams.get('group') || '',
            },
            update: new Date().getTime()
        }))

    }, [location.search])

    useEffect(() => {

        if (state.setFilter) {
            Object.entries(state.filter).map(filter => {
                // if (filter[1]) {
                searchParams.set(filter[0], filter[1])
                // }
            })

            let url = '?' + searchParams.toString()

            history.push(url)
        }

    }, [state.setFilter])

    useEffect(() => {
        if (state.update) {
            loadData()
        }
    }, [state.update])


    const loadData = () => {
        setState(prev => ({
            ...prev,
            loading: true
        }))

        let url = 'accounts/profit-vat-report'

        Object.entries(state.filter).map(filter => {
            url += (url.indexOf('?') > -1 ? '&' : '?') + filter[0] + '=' + filter[1]
        })

        Api.get(url)
            .then(res => {

                setState(prev => ({
                    ...prev,
                    data: res.data,
                    filter: {
                        ...prev.filter,
                        group: res.data.group,
                        start: res.data.start,
                        end: res.data.end,
                        profit_tax: res.data.profit_tax
                    },
                    loading: false
                }))
            })
    }

    const handleSearch = (key, val, delay = 300) => {

        setState(prev => ({
            ...prev,
            filter: {
                ...prev.filter,
                [key]: val,
            },
            setFilter: new Date().getTime()
        }))
    }

    const handleExcel = () => {
        let url = `${Constants.App.api}accounts/export-profit-vatreport?token=${auth.token()}`

        Object.entries(state.filter).map(filter => {
            url += (url.indexOf('?') > -1 ? '&' : '?') + filter[0] + '=' + filter[1]
        })

        window.open(url, '_blank', 'noopener,noreferrer')

    }

    const currency = state.data.currency || ''

    const chartLabels = (state.data.dates || []).map(d => d.label)

    const chartSeries = [
        {
            name: trans('labels.incomeTax'),
            color1: getPaletteColor(0).color1,
            color2: getPaletteColor(0).color2,
            data: (state.data.dates || []).map(d => Number(d.vat) || 0),
            valueFormatter: (value) => `${value} ${currency}`,
        },
    ]

    return (
        <>
            <Filter
                filter={state.filter}
                handleSearch={handleSearch}
            />

            <hr />

            {state.loading
                ?
                <img className="loader" src={loader} />
                :
                <>
                    <div
                        className="chart"
                        style={{
                            background: '#fff',
                            padding: '5px'
                        }}>
                        <GroupedBarChart
                            labels={chartLabels}
                            series={chartSeries}
                            roundedBottom
                        />
                    </div>
                    <br />
                    <button onClick={handleExcel}>{trans('buttons.download')}</button>
                    <hr />
                    <div className="table-scroller">
                        <table>
                            <thead>
                                <tr>
                                    <th>
                                        {trans('tables.date')}
                                    </th>
                                    <th className="right">
                                        {trans('tables.income')}
                                    </th>
                                    <th className="right">
                                        {trans('tables.expense')}
                                    </th>
                                    <th className="right">
                                        {trans('tables.difference')}
                                    </th>
                                    <th className="right">
                                        {trans('tables.incomeTax')}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {state.data.dates.map((d, i) =>
                                    <tr key={'d-' + i}>
                                        <td>
                                            {d.label}
                                        </td>
                                        <td className="right">
                                            {d.incomes_formatted}
                                        </td>
                                        <td className="right">
                                            {d.expenses_formatted}
                                        </td>
                                        <td className="right">
                                            {d.diff_formatted}
                                        </td>
                                        <td className="right">
                                            {d.vat_formatted}
                                        </td>
                                    </tr>
                                )}
                                <tr>
                                    <td>
                                        {trans('tables.total')}
                                    </td>
                                    <td className="right">
                                        {state.data.total_incomes_formatted}
                                    </td>
                                    <td className="right">
                                        {state.data.total_expenses_formatted}
                                    </td>
                                    <td className="right">
                                        {state.data.total_diff_formatted}
                                    </td>
                                    <td className="right">
                                        {state.data.total_vat_formatted}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </>
            }

        </>
    )
}

export default ProfitVat